// Maintenance mode (#302), client side. Shared by both SPAs: their callFunction
// reports the api's `maintenance` 503 here, and MaintenanceGate listens and
// takes over the screen. See embertracking/api/src/lib/maintenance.js.

export const MAINTENANCE_CODE = 'maintenance';

let reported = null;
const listeners = new Set();

export const reportMaintenance = message => {
    reported = {maintenance: true, message: message || null};
    listeners.forEach(listener => listener(reported));
};

export const clearReportedMaintenance = () => {
    reported = null;
};

export const getReportedMaintenance = () => reported;

export const subscribeMaintenance = listener => {
    listeners.add(listener);
    return () => listeners.delete(listener);
};

// bin/operator-login.js opens /login#operatorToken=…, and the login page strips
// the fragment before signing in. The gate has to see it first, so it can let
// that login page render while the project is closed to everyone else.
export const hasOperatorHandoff = (hash = '') => /(?:^#|&)operatorToken=/.test(hash);
